import { createMiddlewareFromEventsMap } from '@noths/polaris-client-next-redux';

import { GAEventsMap as deliveryBlockGAEventsMap } from 'src/components/organisms/DeliverySection/modules/tracking/eventsMap';
import { GAEventsMap as favouritesGAEventsMap } from 'src/components/organisms/Favourites/tracking/eventsMap';
import { GAEventsMap as productImagesCarouselGAEventsMap } from 'src/components/organisms/ProductImagesCarousel/tracking/eventsMap';
import { GAEventsMap as productInfoGAEventsMap } from 'src/redux/productInfo/eventsMap';
import { GAEventsMap as basketGAEventsMap } from './basket';
import type { ReduxApplicationState } from './combinedReducer';
import { GAEventsMap as deliveryGAEventsMap } from './delivery/tracking/eventsMap';
import { GAEventsMap as personalisationGAEventsMap } from './personalisation/tracking/eventsMap';

export const eventsMap = {
  ...basketGAEventsMap,
  ...deliveryBlockGAEventsMap,
  ...deliveryGAEventsMap,
  ...favouritesGAEventsMap,
  ...personalisationGAEventsMap,
  ...personalisationGAEventsMap,
  ...productImagesCarouselGAEventsMap,
  ...productInfoGAEventsMap,
};

export const GAMiddleware = createMiddlewareFromEventsMap<ReduxApplicationState>(eventsMap);
